import {
  Authority,
  cancelSubscription,
  dashboardDateFormatter,
  openNotification,
  useDocumentTitle,
} from "@dataone/lib";
import { useMutation } from "@tanstack/react-query";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";
import { styled } from "styled-components";
import { useAuth } from "../../auth/contexts/auth.provider";
import { withAuth } from "../../auth/helpers/hoc";
import dayjs from "dayjs";

interface SubscriptionSettingsPageProps {
  children?: React.ReactNode;
}

const SubscriptionSettingsPage = () => {
  const { isLoading, mutate: cancelSub } = useMutation(cancelSubscription);
  useDocumentTitle("OneGate | Subscription settings");

  const { user, getCurrentUser } = useAuth();
  const navigate = useNavigate();

  const handleCancelSubscription = () => {
    if (
      user?.groups[0] === Authority.OG_SUBSCRIBER_EX ||
      user?.subscription?.type === "FREE"
    )
      navigate("/subscription");
    else
      cancelSub(undefined, {
        onSuccess: ({ message }) => {
          getCurrentUser();
          openNotification(message);
        },
      });
  };

  const subscriptionEndDate = user?.subscription?.currentPeriodEnd
    ? dayjs(user.subscription.currentPeriodEnd).format("MM-DD-YYYY")
    : "N/A";

  return (
    <StyledSubscriptionSettingsPage>
      <h2>Subscription Settings</h2>
      <StyledContent>
        <StyledDescription>
          <div>Manage your subscription renewal and cancellation</div>
        </StyledDescription>
        <StyledForm>
          <StyledSubscriptionContent>
            <StyledSecondCard>
              <div style={{ flex: "1 1 54%" }}>
                <div>
                  <StyledTitleSub>
                    {user?.groups[0] === Authority.OG_SUBSCRIBER_EX
                      ? "Expired subscription"
                      : "Cancel subscription"}
                  </StyledTitleSub>
                  <StyledSubTitle>
                    {user?.groups[0] === Authority.OG_SUBSCRIBER_EX
                      ? "Your subscription has expired. To regain access to our services, please proceed to reactivate your subscription."
                      : user?.subscription?.type === "FREE"
                      ? `Your free trial will end on ${subscriptionEndDate}. If you want to continue using our services, please subscribe.`
                      : user?.subscription?.cancelled
                      ? `Your subscription has been cancelled. You will still have access to the platform until ${subscriptionEndDate} and your subscription will not be renewed.`
                      : `Next billing date is ${subscriptionEndDate}. If you cancel now, you will still have access to the platform until that date and your subscription will not be renewed.`}
                  </StyledSubTitle>
                </div>
              </div>
              <div style={{ flex: "1 1 43%" }}>
                <StyledButton
                  onClick={handleCancelSubscription}
                  disabled={
                    isLoading ||
                    (user?.subscription?.cancelled &&
                      user?.subscription?.type !== "FREE" &&
                      user?.groups[0] !== Authority.OG_SUBSCRIBER_EX)
                  }
                >
                  {user?.groups[0] === Authority.OG_SUBSCRIBER_EX
                    ? "Subscribe"
                    : user?.subscription?.type === "FREE"
                    ? "Upgrade"
                    : user?.subscription?.cancelled
                    ? "Already cancelled"
                    : isLoading
                    ? "Cancelling"
                    : " Yes , cancel ! "}
                </StyledButton>
              </div>
            </StyledSecondCard>
          </StyledSubscriptionContent>
        </StyledForm>
      </StyledContent>
    </StyledSubscriptionSettingsPage>
  );
};

export default withAuth(SubscriptionSettingsPage, [
  Authority.OG_SUBSCRIBER,
  Authority.OG_SUBSCRIBER_EX,
]);

const StyledSecondCard = styled.div`
  display: flex;
  align-items: center;
`;

const StyledSubTitle = styled.p`
  color: rgba(4, 7, 38, 0.8);
  font-size: 14px;
  margin: 0;
  width: 80%;
`;

const StyledTitleSub = styled.div`
  color: #4974f6;
  font-size: 18px;
  font-weight: 700;
  margin: 0 0 15px 0;
`;

const StyledSubscriptionSettingsPage = styled.div`
  // padding: 30px;
  width: 100%;
  padding: 15px 0px 0px 30px;
  h2 {
    color: #4974f6;
    font-weight: 700;
    font-size: 18px;
    margin-top: 2px;
    margin-bottom: 40px;
  }
  .ant-breadcrumb li:nth-of-type(1) a {
    font-size: 16px !important;
    color: #040726 !important;
    font-weight: 200 !important;
  }

  .ant-breadcrumb a {
    color: #4974f6;
    transition: color 0.2s;
    padding: 0 4px;
    border-radius: 4px;
    display: inline-block;
    margin-inline: -4px;
    font-size: 18px !important;
    font-weight: bold;
    background-color: transparent;
  }
`;

const StyledSubscriptionContent = styled.div``;

const StyledForm = styled.div`
  // width: 65vw;
`;

const StyledDescription = styled.div`
  width: 25vw;
`;

const StyledContent = styled.div`
  // display: flex;
  // gap: 6rem;
  // align-items: flex-start;
  // @media screen and (max-width: 1200px) {
  display: flex;
  flex-direction: column;
  gap: 3rem;
  // }
`;

const StyledButton = styled(Button)`
  border-radius: 10px;
  background: #040726;
  box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25) inset;
  color: #ffffff;
  border: none;
  width: 250px;
  &:hover {
    background: #040726;
    color: #ffffff !important;
  }
  &[disabled] {
    color: rgba(0, 0, 0, 0.25) !important;
    background-color: rgba(0, 0, 0, 0.04) !important;
  }
`;
